import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';

export const initSurveySession = (slug: string): string => {
	try {
		if (typeof window === 'undefined' || !slug) {
			console.log('initSurveySession: window is undefined or slug is missing');
			return '';
		}

		const storageKey = `survey_session_${slug}`;
		const storedSessionId = localStorage.getItem(storageKey);
		let currentSessionId = '';

		if (storedSessionId) {
			currentSessionId = storedSessionId;
			console.log(`initSurveySession: Using existing sessionId from localStorage: ${currentSessionId}`);
		} else {
			const random = uuidv4().split('-')[0];
			const timestamp = dayjs().valueOf();
			currentSessionId = `session_${timestamp}_${random}`;
			localStorage.setItem(storageKey, currentSessionId);
			console.log(`initSurveySession: Created new sessionId: ${currentSessionId}`);
		}

		return currentSessionId;
	} catch (error) {
		console.error('initSurveySession failed:', error instanceof Error ? error.message : error);
		return '';
	}
};

